// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__XTHOx","profile":"Profile_profile__8rsiP","information":"Profile_information__FEbj-","menu":"Profile_menu__V7q1u","item":"Profile_item__lVyfv"};